<template id="draggableTable">
  <div class="horizontal-scroll">
    <div class="row" :key="componentKey">
      <div v-for="item in list"
           :key="item.list_id"
           class='drop-zone'
           @drop='onDrop($event, item.list_id)'
           @dragover.prevent
           @dragenter.prevent
      >
        <span class="list-title">{{ $t(item.name) }}</span>
        <div class="list-header">
          <span class="text--bold">TOTAL  <i class="fa fa-user"></i> </span>
          &nbsp;
          <span>{{ item.leads && item.leads.length || 0 }} leads</span>
        </div>

        <!--<div class="cards-column">-->
        <div>
          <div
            class='drag-el clickable'
            v-for='lead in item.leads'
            :key='lead.id'
            :draggable=canEdit
            @dragstart='startDrag($event, lead, item.list_id)'
            @click="handleLeadDetail(lead)"
          >
            <!--{{ item.title }}-->
            <leadCard :lead="lead"/>
          </div>
        </div>
      </div>
    </div>
    <LeadDetail
      v-if="showLeadDetailsModal"
      :lead="selectedLead"
      :suppliers="suppliers"
      :list="list"
      :canEdit="canEdit"
      :readEntities="readEntities"
      :writableEntities="writableEntities"
      @cancel="leadDetailsModalClosed"
      @lead-updated="handleLeadUpdated"/>

    <ConfirmationModal
      v-if="showConfirmationModal"
      :title="getConfirmationModalTitle"
      :body="getConfirmationModalBody"
      @modal-confirmed="handleConfirmMove"
      @modal-canceled="handleConfirmationCanceled"/>
  </div>
</template>

<script>
import LeadCard from '@/components/leads-web/dashboard/LeadCard'
import LeadDetail from '@/components/leads-web/dashboard/LeadDetail'
import { LeadsWebService } from '@/api/LeadsWebService'
import { mapState } from 'vuex'
import ConfirmationModal from '@/components/common/ConfirmationModal'

const LEADS_WEB_INFO_TYPE = 3000
const COLUMN_TYPE_ACTION = 'action'
const COLUMN_TYPE_STATUS = 'status'

export default {
  components: { LeadDetail, LeadCard, ConfirmationModal },
  props: {
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    writableEntities: {
      type: Array,
      required: true
    },
    readEntities: {
      type: Array,
      required: true
    },
    leads: {
      type: Array,
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    suppliers: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      componentKey: 0,
      showLeadDetailsModal: false,
      selectedLead: null,
      showConfirmationModal: false,
      leadToMove: null,
      stageToMove: {}
    }
  },
  created () {

  },
  methods: {
    handleLeadUpdated (lead) {
      this.$emit('lead-updated', lead)
      this.showLeadDetailsModal = false
    },
    handleLeadDetail (lead) {
      this.selectedLead = lead
      this.showLeadDetailsModal = true
    },
    leadDetailsModalClosed () {
      this.showLeadDetailsModal = false
      this.selectedLead = null
    },
    startDrag: (evt, lead, column) => {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('leadId', lead.id)
      evt.dataTransfer.setData('lastColumnId', column)
    },

    onDrop (evt, columnId) {
      const leadId = evt.dataTransfer.getData('leadId')
      const lastColumnId = evt.dataTransfer.getData('lastColumnId')
      // Find the whole lead to transfer to destination
      let originColumn = this.list.find(elem => elem.list_id == lastColumnId)
      let lead = originColumn.leads.find(lead => lead.id == leadId)
      // Add the lead to destination only if destination column != original column
      let destinationColumn = this.list.find(elem => elem.list_id == columnId)

      if (originColumn.list_id !== destinationColumn.list_id) {
        destinationColumn.leads.push(lead)
        // Remove from the old column
        let idx = originColumn.leads.findIndex(lead => lead.id == leadId)
        delete originColumn.leads.splice(idx, 1)

        this.leadToMove = lead
        this.stageToMove = {
          id: destinationColumn.id,
          type: destinationColumn.type,
          name: destinationColumn.name
        }
        this.showConfirmationModal = true
      }

      this.componentKey += 1
    },
    handleConfirmMove () {
      if (this.leadToMove && this.stageToMove) {
        // If lead is going to an action type column, call the action
        if (this.stageToMove.type === COLUMN_TYPE_ACTION) {
          LeadsWebService.runManualAction(this.leadToMove.id, this.stageToMove.id).then(res => {
            this.showToast(this.$t('leads-web.leads.move-success-action', { action: this.stageToMove.name }), this.$store.state.successToastOptions)
          }).catch(err => {
            this.showToast(this.$t('leads-web.leads.move-error'), this.$store.state.errorToastOptions)
            console.log(err)
          }).finally(() => {
            this.leadToMove = null
            this.stageToMove = {}
            this.showConfirmationModal = false
            this.$emit('lead-updated')
          })
        }
        // else if lead is going to a status type column, update it's status only
        else if (this.stageToMove.type === COLUMN_TYPE_STATUS) {
          let data = { ...this.leadToMove }
          data.status.id = this.stageToMove.id
          LeadsWebService.update(this.leadToMove.id, data).then(res => {
            this.showToast(this.$t('leads-web.leads.move-success-status', { status: this.$t(this.stageToMove.name) }), this.$store.state.successToastOptions)
          }).catch(err => {
            console.log(err)
            this.showToast(this.$t('leads-web.leads.move-error'), this.$store.state.errorToastOptions)
          }).finally(() => {
            this.leadToMove = null
            this.stageToMove = {}
            this.showConfirmationModal = false
            this.$emit('lead-updated')
          })
        }
      }
    },
    handleConfirmationCanceled () {
      this.leadToMove = null
      this.stageToMove = {}
      this.showConfirmationModal = false
      this.$emit('lead-updated')
    }
  },
  computed: {
    ...mapState({
      'leadsWebToken': (state) => state.leadsWeb.leadsWebSrvToken
    }),
    getConfirmationModalTitle () {
      return this.stageToMove.type === COLUMN_TYPE_ACTION
        ? this.$t('leads-web.leads.confirm-move-action-title')
        : this.$t('leads-web.leads.confirm-move-status-title')
    },
    getConfirmationModalBody () {
      return this.stageToMove.type === COLUMN_TYPE_ACTION
        ? this.$t('leads-web.leads.confirm-move-action', { name: this.leadToMove.name, action: this.stageToMove.name })
        : this.$t('leads-web.leads.confirm-move-status', {
          name: this.leadToMove.name,
          status: this.$t(this.stageToMove.name)
        })
    },
  }
}
</script>

<style scoped lang="scss">
.drop-zone {
  //background-color: #eee;
  margin-bottom: 10px;
  padding: 10px;
  width: 280px;
  vertical-align: top;
  height: 100%;
}

.drag-el {
  //background-color: #fff;
  margin-bottom: 10px;
  padding: 5px;
}

.list-title {
  font-weight: bold;
  font-size: 18px;
  color: #484949;
}

.list-header {
  background-color: rgb(111, 111, 111);
  border-radius: 6px;
  color: white;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.horizontal-scroll > .row {
  overflow-x: auto;
  white-space: nowrap;
  height: calc(100vh - 300px);
}

.horizontal-scroll > .row > .drop-zone {
  display: inline-block;
  float: none;
}

/* Handle */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #29C4AA;
}

.row {
  display: inherit;
}

.cards-column {
  height: calc(100vh - 250px);
  overflow-y: auto;
}

</style>
